import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { Component, Input, Optional, Self } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { MaskitoElementPredicate, MaskitoOptions } from '@maskito/core';

@Component({
  selector: 'c-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: false,
})
export class InputComponent<T = any> implements ControlValueAccessor {
  @Input() type: 'date' | 'email' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'time' | 'hidden' | 'url' =
    'text';
  @Input() inputMode: 'numeric' | 'decimal' | 'text' = this.type === 'number' ? 'numeric' : 'text';
  @Input() label: string | undefined;
  @Input() placeholder: string | undefined;
  @Input() helpText: string | undefined;
  @Input() minLength: number | undefined;
  @Input() maxLength: number | undefined;
  @Input() showError = true;
  @Input() clearInput = false;
  @Input() icon: string | IconProp;
  // Unset by default so the icon takes the form-field icon colour for its state.
  @Input() iconColor: string | undefined;
  @Input() iconStart = false;
  @Input() maskito: MaskitoOptions | undefined;


  readonly maskPredicate: MaskitoElementPredicate = async (el) => ((el as unknown) as HTMLIonInputElement).getInputElement();

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get control() {
    return this.ngControl?.control as FormControl;
  }

  writeValue(value: any): void {}

  onChange = (value: T) => {};
  onTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
